<sonder-modal
  class="ctr-modal"
  [sonderModalOpen]="modalVisible"
  (sonderModalClosed)="handleCloseModal()"
  [sonderModalCloseable]="!submitting"
  data-test="mark-inactive-modal"
>
  <form
    class="ctr-modal-form"
    [formGroup]="clientTerminationReasonsForm"
    (ngSubmit)="onSubmitClientTerminationReasonsForm()"
    aria-labelledby="client-termination-reason-form-label"
    data-test="client-termination-form"
  >
    <h2 id="client-termination-reason-form-label" class="iris-h2-responsive">Mark {{ displayName }} inactive</h2>
    <p class="iris-body-responsive">A response is required.</p>
    <iris-form-field 
      *ngIf="radioOptions"
      label="Why are you marking this client inactive?"
    >
      <iris-radio-group
        [options]="radioOptions"
        formControlName="reference_data_id"
        aria-label="Select client inactive reason"
      ></iris-radio-group>
    </iris-form-field>

    <div [ngClass]="{'hidden': !isOtherSelected}" class="other-selected-textarea">
      <label class="textarea-label">Please explain:</label>
      <iris-text-area
        formControlName="termination_info"
        placeholder="Add a different reason for marking client inactive"
        [required]="isOtherSelected"
      ></iris-text-area>
    </div>

    <iris-button-container [alignment]="IrisButtonContainerAlignments.END" data-dd-privacy="allow">
      <iris-button
        [disabled]="submitting"
        [buttonType]="IrisButtonTypes.SECONDARY"
        [typeAttribute]="IrisButtonTypeAttributeOptions.BUTTON"
        (click)="handleCloseModal()"
      >
        Cancel
      </iris-button>
      <iris-button
        [disabled]="clientTerminationReasonsForm.invalid || submitting"
        gtagCtaEvent
        label="Marked client inactive"
      >
        Mark inactive
      </iris-button>
    </iris-button-container>
  </form>
</sonder-modal>
